import { withOverviewCardErrorBoundary } from '@ctw/shared/content/overview/with-overview-card-error-boundary';
import { PatientVitalsOverviewCard } from './patient-vitals-overview-card';
import { usePatientVitalsOverviewData } from './use-patient-vitals-overview-data';

export type PatientVitalsOverviewProps = {
  onSeeAllResources: () => void;
};

export const PatientVitalsOverview = withOverviewCardErrorBoundary({
  cardTitle: 'Vitals',
  boundaryName: 'PatientVitalsOverview',
  Component: ({ onSeeAllResources }: PatientVitalsOverviewProps) => {
    const { data, isLoading, hasNoRecords } = usePatientVitalsOverviewData();

    return (
      <PatientVitalsOverviewCard
        data={data}
        isLoading={isLoading}
        emptyState="No vitals records found."
        footerCTA={
          // Keep the CTA visible while loading (chrome renders with a body spinner)
          // and whenever there are records; only hide it once we know there are none.
          isLoading || !hasNoRecords
            ? {
                label: 'All Vitals',
                onClick: () => {
                  onSeeAllResources();
                },
              }
            : undefined
        }
      />
    );
  },
});
